// AUTO-GENERATED SQL Builder (V40 Final) for Payment
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class PaymentSql {
  private ast = new SqlAst('Payment', 'payment');
  public readonly main: any = {};

  public guid: SqlField;
  public bookingId: SqlField;
  public invoiceId: SqlField;
  public gatewayRef: SqlField;
  public method: SqlField;
  public amount: SqlField;
  public currencyCode: SqlField;
  public status: SqlField;
  public paidDate: SqlField;
  public paymentType: SqlField;
  public bookingScheduleId: SqlField;
  public booking: SqlNavHybrid;
  public bookingSchedule: SqlNavHybrid;
  public createdByUser: SqlNavHybrid;
  public invoice: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public ledgerEntryList: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('payment', 'guid', '', 'id', 'payment_guid');
    this.bookingId = new SqlField('payment', 'bookingId', 'booking', 'id', 'payment_booking');
    this.invoiceId = new SqlField('payment', 'invoiceId', 'invoice', 'id', 'payment_invoice');
    this.gatewayRef = new SqlField('payment', 'gatewayRef', '', 'id', 'payment_gatewayRef');
    this.method = new SqlField('payment', 'method', '', 'id', 'payment_method');
    this.amount = new SqlField('payment', 'amount', '', 'id', 'payment_amount');
    this.currencyCode = new SqlField('payment', 'currencyCode', '', 'id', 'payment_currencyCode');
    this.status = new SqlField('payment', 'status', '', 'id', 'payment_status');
    this.paidDate = new SqlField('payment', 'paidDate', '', 'id', 'payment_paidDate');
    this.paymentType = new SqlField('payment', 'paymentType', '', 'id', 'payment_paymentType');
    this.bookingScheduleId = new SqlField('payment', 'bookingScheduleId', 'bookingSchedule', 'id', 'payment_bookingSchedule');
    this.booking = createNavHybrid('payment', 'payment_booking', 'Booking');
    this.bookingSchedule = createNavHybrid('payment', 'payment_bookingSchedule', 'BookingSchedule');
    this.createdByUser = createNavHybrid('payment', 'payment_createdByUser', 'User');
    this.invoice = createNavHybrid('payment', 'payment_invoice', 'Invoice');
    this.updatedByUser = createNavHybrid('payment', 'payment_updatedByUser', 'User');
    this.ledgerEntryList = createNavHybrid('payment', 'payment_ledgerEntryList', 'LedgerEntry');
    this.id = new SqlField('payment', 'id', '', 'id', 'payment_id');
    this.isDeleted = new SqlField('payment', 'isDeleted', '', 'id', 'payment_isDeleted');
    this.createdBy = new SqlField('payment', 'createdBy', '', 'id', 'payment_createdBy');
    this.createdDate = new SqlField('payment', 'createdDate', '', 'id', 'payment_createdDate');
    this.updatedBy = new SqlField('payment', 'updatedBy', '', 'id', 'payment_updatedBy');
    this.updatedDate = new SqlField('payment', 'updatedDate', '', 'id', 'payment_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:PaymentSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:PaymentSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:PaymentSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:PaymentSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:PaymentSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:PaymentSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:PaymentSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:PaymentSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:PaymentSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:PaymentSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
